import nextTick from '../lib/next-tick';

const moduleSelector = '.move-button-on-mobile-js';
// eslint-disable-next-line no-unused-vars
const moduleCallBack = (moduleElement, query, queryAll) => {
    const button = query('.button-container');
    const content = query('.section-content');

    if (button) {
        const buttonOriginalParent = button.closest('div');
        const setButtonPosition = () => {
            buttonOriginalParent.classList.add('button-parent-js');
            if (window.innerWidth <= 767) {
                content.append(button);
                button.classList.add('text-center');
            } else {
                buttonOriginalParent.append(button);
                button.classList.remove('text-center');
            }
        };
        setButtonPosition();
        window.addEventListener('resize', setButtonPosition);
        window.addEventListener('DOMContentLoaded', setButtonPosition);
        window.addEventListener('resize', () => {
            nextTick(setButtonPosition);
        });
    }
};

export { moduleSelector, moduleCallBack };
